import { Injectable, inject } from '@angular/core';
import { WalletPassApi } from '../apis/wallet-pass.api';
import { WalletPassRequest, WalletPassResult } from '../interfaces/wallet-pass';

/**
 * Service che wrappa `WalletPassApi` per la generazione di Google Wallet link
 * e Apple .pkpass tramite gli endpoint del client `Sia.WalletPass.Client`.
 *
 * Pensato per essere consumato sia da componenti Angular sia da script JS
 * eseguiti via `SiaBaseScriptComponent.execScript` (vedere i metodi
 * `generateGoogleWalletPass`/`generateAppleWalletPass`/`generateWalletPass`
 * decorati con `@MethodInfo`).
 */
@Injectable({ providedIn: 'root' })
export class WalletPassService {
  private walletPassApi = inject(WalletPassApi);

  /** Genera solo il "Save to Google Wallet" link. */
  generateGoogle(request: WalletPassRequest): Promise<WalletPassResult> {
    return this.walletPassApi.generateGoogle(request);
  }

  /** Genera solo l'URL magic-link .pkpass per Apple Wallet. */
  generateApple(request: WalletPassRequest): Promise<WalletPassResult> {
    return this.walletPassApi.generateApple(request);
  }

  /** Genera entrambi i wallet pass (Google + Apple). */
  generateBoth(request: WalletPassRequest): Promise<WalletPassResult> {
    return this.walletPassApi.generateBoth(request);
  }
}
